function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "18",
  viewBox: "0 0 12 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.606 4.077c.054-.097.13-.119.228-.065l3.074 1.703c.097.054.119.13.065.228l-5.379 9.703a.555.555 0 01-.22.24l-3.065 2.08a.2.2 0 01-.207.01.199.199 0 01-.102-.182l.14-3.7a.566.566 0 01.088-.314zm-4.584 10.55c-.071-.162-.123-.19-.298-.157l-.548.105-.08 2.135c.342.074.822.357 1.067.608l1.766-1.217-.202-.52c-.064-.167-.116-.195-.289-.17l-.489.067a.693.693 0 01-.44-.062.692.692 0 01-.285-.34zM9.906.554c1.028.57 1.224 1.252.654 2.28L9.52 4.71c-.053.097-.13.12-.227.065L6.22 3.072c-.097-.054-.12-.13-.066-.228L7.194.969C7.764-.06 8.446-.255 9.474.315l.432.24zM4.452 17.911c-.126 0-.205-.46-.205-.699 0-.205.079-.7.205-.7h6.99c.127 0 .22.495.22.7 0 .239-.093.7-.22.7h-6.99z",
  fill: "#000",
  fillRule: "nonzero",
  opacity: ".8"
})));